import { useLingui } from '@lingui/react';
import { Tabs, useMatches } from '@mantine/core';
import { Icons } from '../Shares/Icons';
export const GameDescriptionTabList: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const iconSize = useMatches({
    base: 20,
    sm: 24
  });
  return <Tabs.List flex={1}>
      <Tabs.Tab value="info" leftSection={<Icons className="icon-pr-flat-info" fontSize={iconSize} />}>
        {i18n._('Game info')}
      </Tabs.Tab>
      <Tabs.Tab value="overview" leftSection={<Icons className="icon-pr-flat-playing-cards" fontSize={24} />}>
        {i18n._('Game overview')}
      </Tabs.Tab>
      <Tabs.Tab value="play" leftSection={<Icons className="icon-pr-flat-question-mark" fontSize={24} />}>
        {i18n._('How to play')}
      </Tabs.Tab>
      <Tabs.Tab value="key" leftSection={<Icons className="icon-pr-flat-features" fontSize={24} />}>
        {i18n._('Key features')}
      </Tabs.Tab>
    </Tabs.List>;
};